import { isEmptyObject } from "../../utils/Utils";
import CONSTANT from "../../constants/Constant";
import { setQuestionAnswer } from "../../features/editAssessment/editAssessmentSlice";
import routes from "../../constants/Routes";

export const getNoCCQuestion = (responses) => {
    if(isEmptyObject(responses)) {
        return false;
    }

    let noCCQuestion = null;
    responses.forEach((response) => {
        if(response?.answerTitle?.toString()?.toLowerCase().includes("no")) {
            noCCQuestion = response;
        }
    });

    return noCCQuestion;
}

export const isCCQuestionAnswered = (ccQuestion) => {
    if (isEmptyObject(ccQuestion)) {
        return false;
    }

    const answerId = ccQuestion.answerId;
    const answerValue = ccQuestion.answerValue;

    const hasAnswerId = (answerId !== undefined && answerId !== null && answerId !== '');
    const hasAnswerValue = (answerValue !== undefined && answerValue !== null && String(answerValue).trim() !== "");

    return hasAnswerId || hasAnswerValue;
}

export const getIndexOfCurrentGroup = (groups, currentGroupId) => {
    return groups.findIndex(group => group.groupId === currentGroupId);
}

export const doesHaveAnswerIdRequired = (question) => {
    let needAnswerId = true;

    if(
        (
            question?.responseType === CONSTANT.ELEMENT_TYPES.TEXT ||
            question?.responseType === CONSTANT.ELEMENT_TYPES.CALCULATION ||
            question?.responseType === CONSTANT.ELEMENT_TYPES.NUMBER ||
            question?.responseType === CONSTANT.ELEMENT_TYPES.DATE_PICKER
        )
    ) {
        needAnswerId = false;
    }

    return needAnswerId;
}

export const indexOfGroupId = (groups, groupId) => {
    return groups.findIndex(group => group.groupId === groupId);
}

export const getClickQuestionSubGroupIndex = (currentGroup, questionId) => {
    let tempSubGroupIndex = -1;

    const subGroups = currentGroup?.subGroups || [];

    subGroups.forEach(((subGroup, subGroupIndex) => {
        subGroup.questions.forEach(question => {
            if(question.questionId === questionId) {
                tempSubGroupIndex = subGroupIndex;
            }
        });
    }))

    return tempSubGroupIndex;
}

export const getQuestionIdsOfOSWScore = (obj) => {
    let questionIds = [];
    const regionNames = Object.keys(CONSTANT.OUTCOME_SCORE_QUESTIONS);
    regionNames.forEach(name => {
        const singleRegionQuestionIds = Object.values(CONSTANT.OUTCOME_SCORE_QUESTIONS[name]);
        questionIds = [...questionIds, ...singleRegionQuestionIds];
    });

    return questionIds;
}

export const getUniqueQuestionIdsInSecondArray = (existingIds, newIds) => {
    return newIds.filter(id => !existingIds.includes(id));
}

export const getObjForUpdatingAnswerAtRedux = (questionId, responseId, responseValue, tempSubGroupIndex) => {
    return {
        questionId: questionId,
        answerId: responseId,
        answerValue: responseValue,
        subGroupIndex: tempSubGroupIndex
    }
}

export const isAllGroupCompletedExceptOSW = (groups) => {
    let isAllGroupCompleted = true;

    groups.forEach(group => {
        if(group.groupId !== CONSTANT.ASSESSMENT_GROUP.OUTCOME_ASSESSMENT.key) {
            if(!group.groupCompleted) {
                isAllGroupCompleted = false;
            }
        }
    });

    return isAllGroupCompleted;
}


export const isAllAssessmentCompleted = (groups, ccQuestion) => {
    // 1. Check Chief Complaint first
    if (ccQuestion && !isEmptyObject(ccQuestion)) {
        // If CC is visible but not answered, then we are not complete
        if (!ccQuestion.isDefaultHide && !isCCQuestionAnswered(ccQuestion)) {
            return false;
        }
    }

    // 2. Check all core topics in the state
    if (groups && groups.length > 0) {
        for (const group of groups) {
            // Exclude sections that don't block the Resume FA button
            if (group.groupId === CONSTANT.ASSESSMENT_GROUP.BIOMETRIC.key || 
                group.groupId === CONSTANT.ASSESSMENT_GROUP.OUTCOME_ASSESSMENT.key) {
                continue;
            }

            const subGroups = group.subGroups || [];
            for (const subGroup of subGroups) {
                const questions = subGroup.questions || [];
                for (const question of questions) {
                    // Skip hidden or non-input question types
                    if (question.isDefaultHide) continue;
                    if (question.responseType === CONSTANT.ELEMENT_TYPES.LABEL || 
                        question.responseType === CONSTANT.ELEMENT_TYPES.CALCULATION ||
                        question.responseType === CONSTANT.ELEMENT_TYPES.BUTTON) {
                        continue;
                    }

                    // If we find even one visible question without an answer, it's not complete
                    if (!isCurrentQuestionAnswered(question)) {
                        return false;
                    }
                }
            }
        }
    }

    // If we've scanned everything and found no visible unanswered mandatory questions, it's complete.
    return true;
};


export const isCurrentQuestionAnswered = (question) => {
    if (!question) return false;

    // Check Multi-select
    if (question.responseType === CONSTANT.ELEMENT_TYPES.CHECKBOX || 
        question.responseType === CONSTANT.ELEMENT_TYPES.MULTISELECT) {
        return !!(question.answerList && question.answerList.length > 0);
    }

    // Allow 0 (valid for labels/buttons), but reject undefined, null, or empty strings.
    const answerId = question.answerId;
    const answerValue = question.answerValue;

    const hasAnswerId = (answerId !== undefined && answerId !== null && answerId !== '');
    const hasAnswerValue = (answerValue !== undefined && answerValue !== null && String(answerValue).trim() !== "");

    if (hasAnswerId || hasAnswerValue) {
        // SPECIAL CASE: For Height and Weight related questions, 0 is NEVER a valid answer
        const vitalQuestionIds = [
            CONSTANT.CHATBOT_ACCOUNT.HEIGHT,
            CONSTANT.CHATBOT_ACCOUNT.WEIGHT,
            'heightInFeet', 
            'heightInInch',
            CONSTANT.CHATBOT_ACCOUNT.HEIGHT_IN_FEET,
            CONSTANT.CHATBOT_ACCOUNT.HEIGHT_IN_INCH
        ];

        if (vitalQuestionIds.includes(question.questionId)) {
            const numericValue = Number(answerId || answerValue);
            if (numericValue === 0) return false;
        }

        return true;
    }

    return false;
}

